import React from "react";
import { useTranslation } from "react-i18next";

interface PageSizeSelectorProps {
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  options?: number[];
}

const PageSizeSelector: React.FC<PageSizeSelectorProps> = ({
  pageSize,
  onPageSizeChange,
  options = [10, 20, 50, 100],
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <label className="text-sm text-gray-600">{t("Show")}:</label>
      <select
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-black"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span className="text-sm text-gray-600">{t("per page")}</span>
    </div>
  );
};

export default PageSizeSelector;
